export const toHexColor = (input: string): string => {
  let hash = 0;
  for (let i = 0; i < input.length; i++) {
    hash = input.charCodeAt(i) + ((hash << 5) - hash);
    hash = hash & hash;
  }

  let color = "#";
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 255;
    color += ("00" + value.toString(16)).substr(-2);
  }
  return color;
};

export const invertHex = (hex: string) => {
  return (
    "#" +
    (Number(`0x1${hex.slice(1)}`) ^ 0xffffff)
      .toString(16)
      .substr(1)
      .toUpperCase()
  );
};
